import { motion } from 'framer-motion';
import useStore from '../../Store/store';
import RightMenu from './RightMenu';


const ButtonMenu = ({ proyects}) => {

  const slide = useStore((state) => state.slide);
  const currentSlide = useStore((state) => state.currentSlide);

    return (
        <div className='flex flex-row absolute right-10 space-x-2 items-center'>
            <section className='flex flex-col space-y-4'>
            {
              proyects.map((proyect, index) =>(
                <motion.button
                onClick={() => currentSlide(index)}
                className={` rounded ${slide === index ? 'bg-beige h-8' : 'bg-persian h-2'}`}
                key={index}
                initial={{ width: slide === index ? 8 : 2 }}
                animate={{
                  width: slide === index ? 8 : 8, 
                    scale: slide === index ? 1.2 : 1, // Hace un leve zoom si está activo
                  }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  />
                ))
              }
            </section>
            <section>
              <RightMenu />
            </section>
        </div>
    )

}

export default ButtonMenu